import { action, observable } from 'mobx';
import { startOfDay, endOfDay, add, sub } from 'date-fns';

import store from '../../../store';
import { createVotingForSession } from '../../voting';
import { getCurrentDeputies, formatDateStr } from '../../../utils';

export const formatProtocolTime = date => formatDateStr(sub(new Date(date), { hours: 9 }), 'HH:mm:ss');

export default class ImportStore {

	@observable plenarySession = null;
	@observable session = null;
	@observable canCreate = false;
	@observable error = null;
	@observable isLoading = true;
	@observable date = null;
	@observable protocols = [];
	@observable confError = null;
	@observable deputies = [];
	@observable importInProgress = false;
	@observable notFound = [];
	@observable searching = false;
	
	init = async (id) => {
		this.id = id;
		try {
			this.plenarySession = await store.model.PlenarySession.findById(id, { include: ['meeting'] });
			this.date = this.plenarySession.date ? new Date(this.plenarySession.date) : new Date();
			// this.date = new Date(2021, 3, 16);
			this.deputies = await getCurrentDeputies();
			// console.log('> deputies', this.deputies.map(d => fio(d)));
			await this.checkSession();
			await this.checkDate();
		}
		catch (e) {
			this.error = e.message;
		}
		this.isLoading = false;
	};
	
	onDateChange = async date => {
		this.date = date;
		if (this.session) {
			this.session.protocolDate = date;
			this.confError = null;
			await this.session.save();
			this.checkDate();
		}
	}

	@action checkSession = async () => {
		const sessions = await store.model.Session.find({
			where: { plenarySessionId: this.id },
			include: [
				{ relation:'questions', scope: { order: 'order asc' }},
			],
			order: 'id desc',
		});
		this.session = sessions.length > 0 ? sessions[0] : null;
		if (this.session) this.date = this.session.protocolDate;
	};
	
	@action createSession = async () => {
		this.importInProgress = true;
		await createVotingForSession(this.plenarySession, session => {
			console.log('created session', session);
			this.checkSession();
		});
		this.importInProgress = false;
	};
	
	@action updateSession = async (updates) => {
		this.importInProgress = true;
		const { deletedSessionQuestions, newEpzQuestions } = updates;
		console.log('updateSession', deletedSessionQuestions, newEpzQuestions);

		// опасный функционал, пока выключен
/*
		for (const id of deletedSessionQuestions) {
			const stages = await store.model.SessionQuestionStage.find({ where: { questionId: id }});
			console.log('deleting stages', stages.length);
			await Promise.all(stages.map(r => r.delete()));

			const sessionQuestion = await store.model.SessionQuestion.findById(id);
			console.log('deleting sessionQuestion', sessionQuestion);
			await sessionQuestion.delete();
		}
*/
		
		for (const id of newEpzQuestions) {
			const epzQuestion = await store.model.Question.findById(id);
			console.log('epzQuestion', epzQuestion);
			const sessionQuestion = new store.model.SessionQuestion();
			sessionQuestion.name = epzQuestion.title;
			sessionQuestion.code = 'question';
			sessionQuestion.sessionId = this.session.id;
			sessionQuestion.questionId = epzQuestion.id;
			sessionQuestion.sort = epzQuestion.sort;
			await sessionQuestion.save();
			console.log('created sessionQuestion', sessionQuestion);
		}
		
		await this.session.fixQuestionsOrder();
		await this.checkSession();
		
		this.importInProgress = false;
	};
	
	@action deleteSession = async () => {
		if (!this.session) return;
		console.log('deleting session', this.session.id, '...');
		
		await this.session.deleteSession();
/*

		const votes = await store.model.Vote.find({ where: { sessionId: this.session.id }});
		console.log('deleting votes', votes.length);
		await Promise.all(votes.map(r => r.delete()));
		
		const stages = await store.model.SessionQuestionStage.find({ where: { sessionId: this.session.id }});
		console.log('deleting stages', stages.length);
		await Promise.all(stages.map(r => r.delete()));
		
		const members = await store.model.SessionMember.find({ where: { sessionId: this.session.id }});
		console.log('deleting members', members.length);
		await Promise.all(members.map(r => r.delete()));
		
		console.log('deleting questions', this.session.questions().length);
		await Promise.all(this.session.questions().map(r => r.delete()));
*/

		await this.session.delete();
		console.log('...session deleted');
		
		this.checkSession();
	};
	
	@action checkDate = async () => {
		this.confError = null;
		this.protocols = [];
		
		if (!this.date) {
			this.confError = 'Не выбрана дата';
			return;
		}
		
		console.log('checking date', this.date);
		this.searching = true;
		
		try {
			const date0 = add(startOfDay(new Date(this.date)), { hours: 9 });
			const date1 = add(endOfDay(new Date(this.date)), { hours: 9 });
			this.protocols = await store.model.ConfProtocol.find({
				where: {
					and: [
						{ start: { gte: date0 }},
						{ end: { lte: date1 }},
					],
				},
				order: 'start asc'
			});
			console.log('protocols', this.protocols);
		}
		catch (e) {
			this.confError = e.message;
		}
		
		if (this.protocols.length === 0) {
			this.confError = 'Не найдены протоколы за эту дату.';
		}
		
		if (this.protocols.length > 0 && this.session) {
			this.session.registrationStart = this.protocols[0].start;
			this.session.end = this.protocols[this.protocols.length - 1].end;
			await this.session.save();
		}
		
		this.searching = false;
	};
	
	findDeputyByFIO = (fio) => {
		const arr = fio.trim().split(' ');
		const [ lastName, firstName ] = arr;
		const middleName = arr.slice(2).join(' ');
		const deputy = this.deputies.find(deputy => {
			// console.log('find', deputy.lastName, deputy.firstName, deputy.middleName);
			// return deputy.lastName.trim() === lastName;
			return deputy.lastName.trim() === lastName && deputy.firstName.trim() === firstName && deputy.middleName.trim() === middleName;
		});
		return deputy;
	};
	
}
